import React from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className="flex flex-col justify-center items-center p-8">
            <div>
                <span>ТОО "HajjTravel"</span>
            </div>
            <div>
                <span>{new Date().getFullYear()}.</span>
                <span> Все права защищены.</span>
            </div>
            <div className="flex flex-row gap-4 mt-4">
                <Link className='text-blue-500' to="/privacy-policy">Политика конфиденциальности</Link>
                <Link className='text-blue-500' to="/payment-policy">Условия оплаты</Link>
                <Link className='text-blue-500' to="/refund-policy">Политика возврата и отмены </Link>
            </div>
        </div>
    )
}
export default Footer;